import React, { useState } from "react";

export default function ImagePopup() {
  const [visible, setVisible] = useState(true); // always open

  if (!visible) return null;

  const styles = {
    overlay: {
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.6)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      padding: "10px",
    },
    card: {
      position: "relative",
      maxWidth: "900px",
      width: "100%",
      background: "#fff",
      borderRadius: "16px",
      overflow: "hidden",
      boxShadow: "0 20px 50px rgba(0,0,0,0.3)",
    },
    close: {
      position: "absolute",
      top: "10px",
      right: "15px",
      fontSize: "28px",
      color: "#fff",
      background: "transparent",
      border: "none",
      cursor: "pointer",
      zIndex: 10,
    },
    closeBottom: {
      position: "absolute",
      bottom: "15px",
      right: "15px",
      padding: "8px 16px",
      background: "#000",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontSize: "14px",
    },
    image: {
      width: "100%",
      height: "auto",
      display: "block",
    },
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <button style={styles.close} onClick={() => setVisible(false)}>
          ×
        </button>

        <img
          src="/assets/img/ImagePopup2.png"
          alt="Popup"
          style={styles.image}
        />

        <button style={styles.closeBottom} onClick={() => setVisible(false)}>
          Close
        </button>
      </div>
    </div>
  );
}
